import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { useQuizResults } from '@mentimeter/quiz';
import { ViewOnlyPresentation } from './ViewOnlyPresentation';

export const ViewOnlyPresentationDataHandler = () => {
  const { useQuestion, useConfig, InteractiveCanvasComponents } =
    usePresentationContext();
  const { enableAnimations, readonly } = useConfig();
  const { data = [], isPreviewResults } =
    useQuizResults<QuizPlayersScoreData>();

  const {
    question,
    title_meta,
    question_description,
    choices,
    question_styled,
    layout,
  } = useQuestion();

  const correctAnswer = (choices[0] || {}).label;

  const shouldShowResults = !isPreviewResults || data.length > 0;

  return (
    <ViewOnlyPresentation
      question={question}
      questionStyled={question_styled}
      meta={title_meta}
      description={question_description}
      correctAnswer={correctAnswer}
      layout={layout}
      shouldAnimate={enableAnimations}
      isReadonly={readonly}
      results={shouldShowResults ? data : undefined}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
};
